import React, { useState } from "react";
import "./Order.css";

import { FaEye, FaTrash } from "react-icons/fa";
import { FaFileExport } from "react-icons/fa";
import { FaStar } from "react-icons/fa";
import { FaFilter } from "react-icons/fa"; // Import FontAwesome filter icon
const orders = [
    {
        id: "ORD001",
        date: "2023-06-20",
        name: "John Doe",
        category: "Dine-In",
        payment: "Credit Card",
        amount: "$150.00",
    },
    {
        id: "ORD002",
        date: "2024-06-19",
        name: "Jane Smith",
        category: "Delivery",
        payment: "PayPal",
        amount: "$220.50",
    },
    {
        id: "ORD003",
        date: "2025-06-18",
        name: "Mike Johnson",
        category: "Pick-Up",
        payment: "Debit Card",
        amount: "$340.00",
    },
    {
        id: "ORD002",
        date: "2024-06-19",
        name: "Jane Smith",
        category: "Delivery",
        payment: "PayPal",
        amount: "$220.50",
    },
    {
        id: "ORD003",
        date: "2025-06-18",
        name: "Mike Johnson",
        category: "Pick-Up",
        payment: "Debit Card",
        amount: "$340.00",
    },
];


const getFilteredOrders = (filterType, selectedValue) => {
    if (!selectedValue) return orders;

    return orders.filter((order) => {
        const orderDate = new Date(order.date);
        const currentYear = new Date().getFullYear();

        if (filterType === "Yearly") {
            return orderDate.getFullYear().toString() === selectedValue;
        } else if (filterType === "Monthly") {
            return `${orderDate.getFullYear()}-${(orderDate.getMonth() + 1).toString().padStart(2, "0")}` === selectedValue;
        } else if (filterType === "Weekly") {
            const startOfWeek = new Date(orderDate);
            startOfWeek.setDate(orderDate.getDate() - orderDate.getDay());
            return startOfWeek.toISOString().slice(0, 10) === selectedValue;
        }

        return true;
    });
};
const CouponsTable = () => {
    const [showDetails, setShowDetails] = useState(false);
    const [filterType, setFilterType] = useState("");
    const [selectedValue, setSelectedValue] = useState("");

    const uniqueYears = [...new Set(orders.map((order) => new Date(order.date).getFullYear().toString()))];
    const uniqueMonths = [...new Set(orders.map((order) => `${new Date(order.date).getFullYear()}-${(new Date(order.date).getMonth() + 1).toString().padStart(2, "0")}`))];

    const filteredOrders = getFilteredOrders(filterType, selectedValue);
    const [filters, setFilters] = useState({ name: "", orderType: "", payment: "" });
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [currentFilter, setCurrentFilter] = useState("");



    const [selectedYear, setSelectedYear] = useState("2024");
    const [selectedMonth, setSelectedMonth] = useState("06");
    const [selectedWeek, setSelectedWeek] = useState("");
    const data = [
        { orderId: "ORD001", date: "21-06-2024", particular: "25-06-2024", credit: "Promotional credit applied", debit: "Phone Pay", amount: 500 },
        { orderId: "ORD002", date: "21-08-2024", particular: "30-08-2024", credit: "Promotional credit applied", debit: "Wallet", amount: 500 },
        { orderId: "ORD003", date: "12-06-2023", particular: "21-06-2024", credit: "Promotional credit applied", debit: "Paytm", amount: 500 },
        { orderId: "ORD004", date: "21-06-2024", particular: "26-06-2024", credit: "Promotional credit applied", debit: "Phone Pay", amount: 500 },
        { orderId: "ORD005", date: "21-08-2024", particular: "30-06-2024", credit: "Promotional credit applied", debit: "Wallet", amount: 500 },
        { orderId: "ORD006", date: "12-06-2023", particular: "1-07-2024", credit: "Promotional credit applied", debit: "Paytm", amount: 500 },
    ];
    // Function to determine the week number in a month
    const getWeekOfMonth = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        return Math.ceil(day / 7); // 1st-7th = Week 1, 8th-14th = Week 2, etc.
    };

    // Show all data initially, filter only if year and month are selected


    // Filter Data
    // Function to format the date for display (if needed)
    const formatDate = (dateStr) => {
        const date = new Date(dateStr.split('-').reverse().join('-')); // Reverse the date to use Date constructor
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Apply the filtering logic
    let filteredData =
        selectedYear && selectedMonth
            ? data.filter((item) => {
                const [itemDay, itemMonth, itemYear] = item.date.split("-");  // Split the DD-MM-YYYY format
                return itemYear === selectedYear && itemMonth === selectedMonth;
            })
            : data;

    // Apply other filters
    filteredData = filteredData.filter((item) => {
        return (
            (filters.name ? item.particular.toLowerCase().includes(filters.name.toLowerCase()) : true) &&
            (filters.orderType ? item.credit.toLowerCase().includes(filters.orderType.toLowerCase()) : true) &&
            (filters.payment ? item.debit.toLowerCase().includes(filters.payment.toLowerCase()) : true)
        );
    });

    // Use formatDate to display the date in DD-MM-YYYY
    const displayData = filteredData.map((item) => ({
        ...item,
        date: formatDate(item.date),  // Format the date for display purposes
    }));

    console.log(displayData);

    // Open Popup
    const openPopup = (filterType) => {
        setCurrentFilter(filterType);
        setIsPopupOpen(true);
    };

    // Handle Filter Change
    const handleFilterChange = (e) => {
        setFilters({ ...filters, [currentFilter]: e.target.value });
    };
    const handleToggle = () => {
        setShowDetails((prev) => !prev);
    };




    return (
        <div style={{ marginTop: '33px', height: "520px", overflowY: "auto",
        // width:"1005px" 
        }}>


            <div style={{ height: "260px", borderRadius: "10px", marginBottom: "20px" }}>

                <div 
                style={{ 
                    // width: "920px",
                    //  marginLeft: "65px"
                      }}>

                    <div
                        style={{

                            background: "#f9f9f9",
                            borderRadius: "10px",
                            marginTop: "10px",
                            // padding: "20px",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            // marginLeft: "-16px",
                        }}
                    >
                        {/* Dropdown for Year Selection */}
                        <select
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                            style={{ marginRight: "10px", padding: "5px", borderRadius: "5px", border: "1px solid #ccc" }}
                        >
                            <option value=""> Year</option>
                            <option value="2024">2024</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                        </select>

                        {/* Dropdown for Month Selection */}
                        <select
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(e.target.value.padStart(2, "0"))}
                            style={{ marginRight: "10px", padding: "5px", borderRadius: "5px", border: "1px solid #ccc" }}
                        >
                            <option value="">Select Month</option>
                            <option value="01">January</option>
                            <option value="02">February</option>
                            <option value="03">March</option>
                            <option value="04">April</option>
                            <option value="05">May</option>
                            <option value="06">June</option>
                            <option value="07">July</option>
                            <option value="08">August</option>
                            <option value="09">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                        </select>

                        {/* Dropdown for Week Selection */}
                        <select
                            value={selectedWeek}
                            onChange={(e) => setSelectedWeek(e.target.value)}
                            style={{ padding: "5px", borderRadius: "5px", border: "1px solid #ccc" }}
                        >
                            <option value="">Select Week</option>
                            <option value="1">Week 1</option>
                            <option value="2">Week 2</option>
                            <option value="3">Week 3</option>
                            <option value="4">Week 4</option>
                            <option value="5">Week 5</option>
                        </select>
                        <select
                            // value={selectedWeek}
                            // onChange={(e) => setSelectedWeek(e.target.value)}
                            style={{ padding: "5px", borderRadius: "5px", border: "1px solid #ccc", marginLeft: "10px" }}
                        >
                            <option value=""> Today</option>
                            <option value="1">30-03-2025</option>
                            <option value="2">29-03-2025</option>
                            <option value="3">28-03-2025</option>

                        </select>



                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button
                                style={{
                                    // padding: "8px 15px",
                                    background: "#ee6521",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "3px",
                                    marginTop: "-34px",
                                    marginLeft: "auto", // Pushes button to the right
                                }}
                            >
                                <FaFileExport style={{ fontSize: "20px" }} />
                                Export
                            </button>
                        </div>


                        {/* Table */}
                        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px", marginLeft: "-0px" }}>
                            <thead>
                                <tr style={{ background: "rgb(177 93 198)", textAlign: "left", color: "#fff" }}>
                                    <th>Order Id</th>
                                    <th>Start Date</th>
                                    <th style={{ cursor: "pointer" }} onClick={() => openPopup("name")}>
                                    End Date <FaFilter style={{ marginLeft: "5px", color: "#fff" }} />
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => openPopup("orderType")}>
                                        Description  <FaFilter style={{ marginLeft: "5px", color: "#fff" }} />
                                    </th>
                                    {/* <th style={{ cursor: "pointer" }} onClick={() => openPopup("payment")}>
                                        Payment <FaFilter style={{ marginLeft: "5px", color: "#fff" }} />
                                    </th>
                                    <th>Amount</th> */}
                                    {/* <th style={{ padding: "10px" }}>Ratings</th> */}
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ color: "#000", fontWeight: "normal" }}>{row.orderId}</td> {/* Use orderId here */}
                                            <td style={{ color: "#000", fontWeight: "normal" }}>{row.date}</td>
                                            <td style={{ color: "#000", fontWeight: "normal" }}>{row.particular}</td>
                                            <td style={{ color: "#000", fontWeight: "normal" }}>{row.credit}</td>
                                            {/* <td style={{ color: "#000", fontWeight: "normal" }}>{row.debit}</td>
                                            <td style={{  color: "#000", fontWeight: "normal" }}>₹{row.amount}</td> */}
                                            {/* <td style={{ padding: "10px", color: "#000", fontWeight: "normal" }}>
                                                {Array.from({ length: 5 }, (_, i) => (
                                                    <FaStar key={i} style={{ color: i < row.rating ? "gold" : "gold" }} />
                                                ))}
                                            </td> */}
                                            <td>
                                                <FaEye style={{ cursor: "pointer", marginLeft: "20px", color: "#ee6521" }} />
                                                {/* <FaTrash style={{ cursor: "pointer", color: "#ee6521" }} /> */}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: "center", padding: "10px" }}>
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {isPopupOpen && (
                            <div
                                style={{
                                    position: "fixed",
                                    marginTop: "-99px",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    backgroundColor: "#fff",
                                    padding: "20px",
                                    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                                    borderRadius: "8px",
                                    zIndex: 1000,
                                    width: "300px",
                                    textAlign: "center",
                                    position: "relative", // Make sure the close button is positioned relative to this
                                }}
                            >
                                {/* Close Button (✖) */}
                                <button
                                    onClick={() => setIsPopupOpen(false)}
                                    style={{
                                        position: "absolute",
                                        top: "10px",
                                        right: "10px",
                                        background: "transparent",
                                        border: "none",
                                        fontSize: "18px",
                                        cursor: "pointer",
                                        color: "#333",
                                    }}
                                >
                                    ✖
                                </button>

                                <h3>Filter by {currentFilter === "name" ? "Name" : currentFilter === "orderType" ? "Order Type" : "Payment"}</h3>
                                <input
                                    type="text"
                                    placeholder={`Enter ${currentFilter}`}
                                    value={filters[currentFilter]}
                                    onChange={handleFilterChange}
                                    style={{ width: "100%", padding: "8px", margin: "10px 0", borderRadius: "4px" }}
                                />
                                <button
                                    onClick={() => setIsPopupOpen(false)}
                                    style={{ padding: "8px 12px", background: "rgb(177 93 198)", color: "#fff", borderRadius: "4px", border: "none" }}
                                >
                                    Apply
                                </button>
                            </div>
                        )}

                    </div>


                </div>

            </div>





            <div style={{ position: "fixed", bottom: "0px", left: "0px", height: '30px', width: "100%", backgroundColor: "white", color: "black", textAlign: "center", padding: "5px", fontWeight: "bold", fontSize: "14px", boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)" }}>
                @Envision Integrated Services Pvt Ltd - Empowering Your Future 🚀
            </div>
        </div>
    );
};

export default CouponsTable;
